<template>
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1">
      <podcast-settings-general :feed-prop="feed" />
    </div>

    <div id="discovery" class="col-12 col-lg-10 offset-lg-1">
      <podcast-settings-discovery />
    </div>

    <div id="author_details" class="col-12 col-lg-10 offset-lg-1">
      <podcast-settings-author-details />
    </div>

    <div id="advanced" class="col-12 col-lg-10 offset-lg-1">
      <podcast-settings-advanced :feed-prop="feed" />
    </div>
  </div>
</template>

<script>
import PodcastSettingsGeneral from "VuePartials/Feeds/PodcastSettings/General";
import PodcastSettingsDiscovery from "VuePartials/Feeds/PodcastSettings/Discovery";
import PodcastSettingsAuthorDetails from "VuePartials/Feeds/PodcastSettings/AuthorDetails";
import PodcastSettingsAdvanced from "VuePartials/Feeds/PodcastSettings/Advanced";

export default {
  components: {
    PodcastSettingsGeneral,
    PodcastSettingsDiscovery,
    PodcastSettingsAuthorDetails,
    PodcastSettingsAdvanced,
  },
  data() {
    return {
      feed: {
        name: null,
        description: null,
        ordering: 1,
        itunes_detail: {
          explicit: 'no',
          type: 'serial',
        },
      },
    };
  },

};
</script>
